<template>
	<div>
		<Breadcrumbs main="" title="require.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid search-page">
			<div class="row">
                <div class="col-sm-6 gradient-wy">
                    <form class="theme-form">
                        <div class="row ml-1">
                            <div v-if="!showBkgIdInput"  class="col-sm-4">
                                <label for="selectedBkgId" class="col-form-label pt-0 f-w-600" style="font-size:18px;">{{ $t("require.bkgId") }}</label>                                    
                                <router-link to="/resource/bookingId">
                                    <feather  v-show="!showBkgIdInput" v-b-tooltip.hover :title="$t('bookingId.addBooking')" type="plus-circle" class="ml-2"></feather>
                                </router-link>
                                <v-select label="selectedBkgId" class="style-chooser" style="font-size:16px;" v-model="selectedBkgId" :options="bkgIdList" :placeholder="$t('require.bkgIdPh')">                                        
                                    <template #no-options>
                                        {{$t('reuse.noMatchingOptions')}}
                                    </template>
                                </v-select>
                            </div>
                            <div v-else class="col-sm-4 ">
                                <router-link to="/resource/bookingId">
                                    <b-button pill size="sm" class="bg-primary mt-4 ml-1">
                                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('bookingId.addBooking') }} </span>
                                    </b-button>                                     
                                </router-link>
                            </div>
                            <div class="col-sm-3 form-group">
                                <label for="distLim" class="col-form-label pt-0 f-w-600" style="font-size:18px;">{{ $t("require.distLim") }}</label>
                                <input v-model="distLim" class="form-control" style="font-size:16px;" type="text" :placeholder="$t('require.distLimPh')" >
                            </div>   
                        </div>   
                        <div class="form-group ml-3 text-primary f-w-600">
                            <div class="row">
                                <label for="contReqrAddress" class="col-form-label pt-0 ml-3">{{ $t("require.locReqr") }}</label>    
                                <p class=" ml-2 fw-bold text-danger"  > {{ $t("require.ifChg") }}</p>
                                <a href="#googleMapReqr"><u class=" ml-2 fw-bold text-info" style="font-size:15px" @click="showAC"> <i class="icofont icofont-map-search mr-2 " style="font-size:25px"></i> Google Map </u></a>                                
                            </div>
                            <!-- <input v-model="contReqrAddress" class="form-control text-info" type="text" id="contReqrAddress" :placeholder="$t('require.locReqrPh') " > -->
                            <span class="f-w-60 text-primary ml-2" style="font-size:14px;"> {{ contReqrAddress }}</span>
                            <h6 class=" ml-3 text-info"> Latitude : {{ locReqr.lat }}  ,  Longitude : {{ locReqr.lng }}</h6>
                        </div>      
                        <div class="row ml-1">
                            <div class="col-sm-6">
                                <label class="f-w-600">{{ $t("require.minDetDate") }}</label>
                                <div class="form-group">
                                    <datepicker input-class="datepicker-here form-control digits" :disabled-dates="disabledDates" :format="format" v-model="minDetDate" ></datepicker>
                                </div>                     
                            </div>                                   
                        </div>  
                        <div class="row ml-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-form-group class="f-w-600" style="font-size: 16px"  :label="$t('require.contSize')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contSize"
                                            :options="optionsContSize"
                                            :aria-describedby="ariaDescribedby"
                                            name="contSize-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="row">
                                <div class="col-sm-12 ml-5">
                                    <b-form-group class="f-w-600" style="font-size: 16px"  :label="$t('require.contType')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contType"
                                            :options="optionsContType"
                                            :aria-describedby="ariaDescribedby"
                                            name="contType-options"
                                            plain
                                            stacked
                                            size="lg"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                            <div class="row">
                                <div class="col-sm-12 ml-5">
                                    <b-form-group class="f-w-600" style="font-size: 16px"  :label="$t('require.contGrade')" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="contGrade"
                                            :options="optionsContGrade"
                                            :aria-describedby="ariaDescribedby"
                                            name="contGrade-options"
                                            size="lg"                                            
                                            plain
                                            stacked
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>  
                            </div>
                        </div>
                        <div class="row col-sm-12 ml-1" v-b-popover.hover.top="$t('require.startReqrDateInfo')">
                            <label class="f-w-600 mr-3" style="font-size:15px" >{{ $t("require.startReqrDate") }}</label>
                            <div class="row form-group ml-2">
                                <datepicker input-class="datepicker-here form-control digits" :disabled-dates="disabledDates" :format="format" v-model="sReqrDate" ></datepicker>
                            </div>                     
                        </div>                                   
                        <div class="row ml-1">
                            <div class="row form-group m-t-5 custom-radio-ml ml-3 " >
                                <h5 class="mr-3">{{ $t('release.jobType') }}</h5>
                                <b-form-group  v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group
                                        class="text-info " 
                                        id="radio-group-jobTypeReqr"
                                        v-model="jobType"
                                        @input="resetReceive"
                                        :aria-describedby="ariaDescribedby"
                                        name="jobType"
                                        plain
                                    >                                
                                        <b-form-radio value="Either" v-b-popover.hover.top="$t('require.eitherInfo')">{{ $t('require.either') }}</b-form-radio>     
                                        <b-form-radio value="Receive" v-b-popover.hover.top="$t('require.receiveInfo')">{{ $t('require.receive') }}</b-form-radio>
                                        <b-form-radio  value="Pick-up" v-b-popover.hover.top="$t('require.pickupInfo')">{{ $t('require.pickup') }}</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group> 
                            </div>
                        </div>  
                        <div v-show="jobType == 'Pick-up'|| jobType == 'Either'"  class="col-sm-12">
                            <div class="row ml-1">
                                <h5 class=" col-form-label pt-0 f-w-600">{{ $t("release.transTruck") }}</h5>  
                            </div>
                            <v-select 
                                class="style-chooser" 
                                style="font-size:16px;" 
                                :options="transCompList" 
                                :reduce="transName => transName.compId" 
                                v-model="selectedTransCompId"  
                                label="transName"
                                :placeholder="$t('release.transCompPh')"
                                > 
                            </v-select>  
                        </div> 
                        <b-modal ref="reqr-modal" hide-footer :title= "$t('release.findingResult')">
                            <div class="d-block text-center">
                                <h4>{{ $t('require.noMatchingCont') }}</h4>
                            </div>
                            <b-button class="my-2" style="font-size:18px;" variant="outline-warning" block @click="doNotModal">
                                {{ $t('require.dontPost') }}
                            </b-button>                            
                            <div class="row " style="align-items:center ">                                   
                                <form @submit.stop.prevent="postItModal">
                                    <div class="row ml-4">
                                        <label class="f-w-600 text-primary mt-1" style="font-size:18px;">{{ $t("require.qty") }}</label>
                                        <div>
                                            <b-form-select  style="font-size:18px;" v-model="reqrQty" :options="reqrQtyList"></b-form-select>     
                                            <!-- <b-form-input class="f-w-600 text-primary" style="font-size:18px;" v-model="reqrQty" type="number" min="1" max="100" step="1"></b-form-input>    -->
                                        </div>
                                    </div>
                                </form>                                           
                                <b-button class="mt-3" variant="outline-info" block @click="postItModal">
                                    <span class="my-5" style="font-size: 18px;">
                                        {{ $t("require.postIt") }}
                                    </span>                                                                             
                                </b-button>                                               
                            </div>   
                        </b-modal>
                        <div class="form-group mt-3 mb-0">
                            <button 
                                class="btn btn-primary btn-block" 
                                style="font-size:20px" 
                                type="button" 
                                @click="handleSearching"

                                >
                                {{ $t('require.searching') }}
                            </button>
                        </div>
                    </form>
                </div>
                <div>
                </div>                
                <div class="col-sm-6" id="googleMapReqr" >
                    <section class="ui one column centered grid mt-5" v-show="showAutoComplete" style="position:relative; z-index: 5;">
                        <div class="column" >
                            <form class="ui left segment small form" >
                                <div class="ui message red" v-show="error">{{ error }}</div>
                                <!-- <div class="ui segment" > -->
                                    <div class="field" >
                                        <div class="row mb-3 col-sm-12">
                                            <div class=" col-sm-1">
                                                <i class="icon times text-primary" style="font-size: 24px;"  @click="offAC" ></i>                                                    
                                            </div>             
                                            <div class="col-sm-11">
                                                <span class="text-warning"> {{ $t('company.donotEnterKey') }}</span>       
                                            </div>                                                      
                                        </div>
                                        <!-- <div class="ui message blue" >{{ compAddress }}</div> -->
                                        <div class="ui right icon input large" :class="{loading:spinner}">
                                            <input 
                                                type="text"
                                                v-b-popover.hover="$t('company.inputLocNameMsg')" 
                                                :title="$t('company.inputLocName')"   
                                                id="autocompleteReqr"
                                                v-model="address"
                                                onkeypress= "return event.keyCode != 13;"
                                            >
                                            <i 
                                                class="dot circle link icon" 
                                                @click="locatorButtonPressed"
                                                v-b-popover.hover.top="$t('company.useCurrPosition')"
                                            ></i>
                                        </div>
                                        <!-- dummy input to fix bug : only one input, make reload if we press ENTER.  -->
                                        <!-- <div class="ui message red" v-show="false">
                                            <input 
                                                type="text" 
                                            >
                                        </div> -->
                                    </div>
                                    <div class="row" @click="clearAddress">
                                        <i class="icon eraser f-10 ml-4 text-danger"  style="font-size: 18px;"></i>
                                        <span class="ml3 text-info" > {{ $t('company.clearAddress') }} </span>
                                    </div>
                                <!-- </div> -->
                            </form>                               
                        </div>
                    </section> 
                    <section id="mapReqr" style="background-color: lightblue;"></section>   
                </div>
            </div>
            <b-alert v-model="showAlertWallet" variant="danger" dismissible class="col-sm-6">
                <h4 class="alert-heading f-w-800">{{ $t("release.walletCompNotEnough")}}</h4>
                <div class="row ml-1">
                    <span>{{ $t("release.balancedAmount") }}</span>
                    <span class="text-dark f-w-800 mx-2" style="font-size: 16px;">{{ balanced}}</span>
                    <span>{{ $t("refill.mUnit") }}</span>
                </div>
                <div>
                    <span>{{ $t("release.refillOrContact") }}</span>
                </div>
            </b-alert>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <h2 class="mb-1 mt-4 f-w-600">{{ $t('require.matchingList') }}</h2>
                        <div class="table-responsive datatable-vue">
                            <b-table
                                selectable
                                select-mode="single"                                
                                sticky-header
                                head-variant="light"
                                table-variant="info"
                                show-empty
                                responsive
                                sort-icon-left
                                stacked="md"
                                selectedVariant="primary"
                                :busy="isBusy"
                                :items="items"
                                :fields="tablefields"
                                :current-page="currentPage"
                                :per-page="perPage"
                                @row-selected="rowSelected"
                            >
                                <template #cell(addressRels)="row" >
                                    <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                                        {{ $t('matchTx.rels') }}
                                    </b-button>
                                </template>
                                <template #cell(selected)="{ rowSelected }">
                                    <template v-if="rowSelected">
                                        <span aria-hidden="true">&check;</span>
                                        <span class="sr-only">{{ $t('require.selected') }}</span>
                                    </template>
                                    <template v-else>
                                        <span aria-hidden="true">&nbsp;</span>
                                        <span class="sr-only">{{ $t('require.notSelected') }}</span>
                                    </template>
                                </template>
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{ $t('require.loading') }}</strong>
                                    </div>
                                </template>
                                <template #cell(contImage)="row" >
                                    <b-button  size="sm" @click="openModalImage(row.item, row.index, $event.target )" class="m-1">
                                        {{ row.item.contNo == 'Dummy' || row.item.contNo == 'dummy' || row.item.contNo == '' ? `${$t('container.dummy')}` : row.item.contNo }}
                                    </b-button>
                                </template>
                                <template #empty>
                                    <h5>{{ $t('reuse.noRecord') }}</h5>
                                </template>
                            </b-table>
                        </div>
                        <b-row>
                            <div class="col-sm-3 ">
                                <b-col class="my-1 ml-3">
                                    <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    class="my-0"
                                    ></b-pagination>
                                </b-col>                             
                            </div>
                            <div class="col-sm-5" >  
                                <b-col class="delete-datatable">
                                    <b-button :disabled = "selected.length == 0 ? true : false" variant="primary" @click="selectBatchRow" class="mb-1" style="font-size:20px">
                                        {{ $t("require.confirmSelected") }} <span class="position-absolute top-0 start-100 translate-middle badge rouned-pill bg-warning">{{ selected.length }}</span>   
                                    </b-button>
                                </b-col>                            
                            </div>          
                            <div class="col-sm-4 " >
                                <b-form-group label-cols="2" :label= "$t('require.perPage')" class="datatable-select">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </div>      
                        </b-row>
                            <!-- Info modal Container Image-->
                        <b-modal id="contModal" :title="modalTitle" ok-only @hide="resetInfoModal">
                            <div class="gradient-yg p-1" >
                                <div class="dashboard">
                                    <div class="image-scroll-container">
                                        <div class="image-scroll" ref="scrollContainer">
                                            <div
                                            class="image-item"
                                            v-for="(image, index) in imageUriModal"
                                            :key="image.id"
                                            >
                                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                                            </div>
                                            <div v-if="imageUriModal.length === 0" class="no-images">
                                            {{$t('approvedTrans.noImageYet') }}
                                            </div>
                                        </div>
                                        <div class="scroll-controls" v-if="imageUriModal.length > 1">
                                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                        </div>
                                    </div>                        
                                </div>
                            </div>
                        </b-modal>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
            <div class="divider"> </div>
            <div>
                <h2 class="mb-1 mt-4 f-w-600">{{ $t('require.postedRequire') }}</h2>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    responsive
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :items="itemsPostedReqr"
                    :fields="fieldsPostedReqr"
                    :current-page="currentPagePostedReqr"
                    :per-page="perPagePostedReqr"
                >
                    <template #cell(addressReqr)="row" >
                        <b-button  size="sm"  class="m-1" v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                            {{ $t('matchTx.reqr') }}
                        </b-button>
                    </template>
                    <template #cell(actPostedReqr)="row" >
                        <b-button v-show="row.item.status == 'Require' " size="sm" @click="actPostedReqrCancel(row.item)" class="m-1">
                            {{ $t('matchTx.cancel') }}
                        </b-button>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPagePostedReqr"
                        :total-rows="totalRowsPostedReqr"
                        :per-page="perPagePostedReqr"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPagePostedReqr"
                            :options="pageOptionsPostedReqr"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                <!-- Info modal Reqr Attch Seal-->
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>

// const axios = require("axios");
import {transCompList, getBalance, uaTxWallet, compNameLocalByCompId, getData, getStatusByDocId, updateStatus ,agentAtBkgId, bkgIdList, locByCompId,saveWithId} from "../../firebase"
import {reqrCost, qtyList, contSize, contType ,contGrade} from '../../constants/config'
import {getRandomInt, showUserLocationOnTheMap } from "../../utilities/util" 
import {getAddressFrom, axiosPost} from "../../utilities/axiosComp" 
export default {
	data(){
		return{
            balanced: 0,
            showBkgIdInput: false,
            showAlertWallet: false,
            transCompList : [],
            selectedTransCompId : '',
            sReqrDate: '',
            disabledDates: {
                // to: new Date(Date.parse(new Date())-7905600000),  // 3 months back
                to: new Date(Date.parse(new Date())-86400000),  // today onward
            },
            showAutoComplete : false,
            bkgIdList : [],
            address : '',
            error : '',        
            spinner: false,
            format: "yyyy-MM-dd",
            reqrId: '',
            selectedBkgId : '',
            contType: '',
            optionsContType : contType,
            contSize: '',
            optionsContSize : contSize,
            contGrade: '',
            optionsContGrade : contGrade, 
            agent: '',
            contReqrAddress: '',
            locReqr : '',
            jobType : '',
            userId: '',
            compId: '',
            minDetDate : '',
            distLim : '50',
            payload : '',
            reqrQtyList :[],
            reqrQty : 1,
            isBusy: false,
            items : [],
            // items: [{"id": 1, "distance":0, "agent":"", "contRelsAddress":"Wait for matching result.","detDate":"YYYY-MM-DD","distLim":50,"contNo":"1","contType":"","contSize":"","contGrade":"","maxGross":"","tare":"","compNameLocal":"******","jobType":"Drop-off","relsId":""}],            
            tablefields: [
                { key: 'selected', label: this.$t('require.selected'), variant: 'warning' },
                { key: 'distance', label: this.$t('require.distance'), sortable: true, variant: 'info' },                 
                { key: 'id', label: this.$t('require.id'), sortable: true, },  
                { key: 'contId', label: this.$t('container.contId'), sortable: true, },  
                { key: 'contImage', label: this.$t('container.contNo'), variant: 'info'},      
                // { key: 'contNo', label: this.$t('require.contNo'), sortable: true, },
                { key: 'agent', label: this.$t('require.agent'), sortable: true, },                
                { key: 'sRelsTS', label: this.$t('release.startRelsDate'), sortable: true, variant: 'warning',
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                 
                { key: 'detDate', label: this.$t('require.detDate'), sortable: true, variant: 'danger' },                
                { key: 'compNameLocalRels', label: this.$t('require.compNameLocalRels'), sortable: true, },                
                { key: 'jobType', label: this.$t('release.jobType'), sortable: true, 
                    formatter: value => {
                        return this.$t(`release.${value}`)
                }},    
                { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false,},
                // { key: 'contRelsAddress', label: this.$t('require.contRelsAddress'), sortable: false, },
                { key: 'contType', label: this.$t('require.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('require.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('require.contGrade'), sortable: true, },
                { key: 'maxGross', label: this.$t('container.maxGross'), sortable: true, },
                { key: 'tare', label: this.$t('container.tare'), sortable: true, },

            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            selected: [],
            imageUriModal: [],
            modalTitle : '',
            // PostedRequire
            itemsPostedReqr: [],
            fieldsPostedReqr: [
                { key: 'reqrId', label: this.$t('require.reqrId'), sortable: true, },  
                { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, },                        
                { key: 'agent', label: this.$t('require.agentByBkgId'), sortable: true, }, 
                { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, },                
                { key: 'jobType', label: this.$t('release.jobType'), sortable: true, 
                    formatter: value => {
                        return this.$t(`require.${value}`)
                }},
                { key: 'sReqrTS', label: this.$t('require.startReqrDate'), sortable: true, variant: 'warning',
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                 
                { key: 'minDetDate', label: this.$t('require.minDetDate'), sortable: true, variant: 'warning'},                 
                { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false, },   
                // { key: 'contReqrAddress', label: this.$t('matchTx.contReqrAddress'), sortable: false, },   
                { key: 'distLim', label: this.$t('require.distLim'), sortable: true, },             
                { key: 'contType', label: this.$t('require.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('require.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('require.contGrade'), sortable: true, },

                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},
                { key: 'status', label: this.$t('matchTx.jobStatus'), variant: 'warning', sortable: true,
                    formatter: value => {
                        return this.$t(`require.${value}`)
                }},
                { key: 'actPostedReqr', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRowsPostedReqr: 1,
            currentPagePostedReqr: 1,
            perPagePostedReqr: 10,
            pageOptionsPostedReqr: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',
            sortDesc: true,
            sortDirection: 'asc',
		}
	},

    computed: {
        // sortOptions() {
        // // Create an options list from our fields
        // return this.tablefields.filter(f => f.sortable).map(f => { return { text: f.label, value: f.key } });
        // }
    },

	mounted(){
        this.totalRows = this.items.length
        let compId= localStorage.getItem("compId")
        let userId= localStorage.getItem("userId")
        this.compId = compId
        this.userId= userId
        this.reqrQtyList = qtyList
        bkgIdList(compId, (res)=>{
            if (res.length == 0) {
                this.showBkgIdInput = true
            } else {
                this.bkgIdList = res
            }
        })
        transCompList(compId, (res)=>{
            this.transCompList = res
        })
        getData( "Require", "compId",this.compId , (res)=>{
            this.itemsPostedReqr = res
            this.totalRowsPostedReqr = res.length
        })
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async(position) =>{ 
                        showUserLocationOnTheMap(position.coords.latitude, position.coords.longitude , "mapReqr" )             
                    },
                error => {
                    this.error = `Error: ${error},Locator is unable to find the address. Please type your address manually.`
                }
            );

        } else {
            this.error = error.message
            this.$toasted.show( error.message, {theme: 'bubble',   position: 'bottom-right',   type: 'error', duration: 15000});
        }  
        var autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocompleteReqr'),
            {
                bounds: new google.maps.LatLngBounds(
                    new google.maps.LatLng(13.555 , 100.50)
                )
            }
        )
        autocomplete.addListener("place_changed",  ()=>{
            let place = autocomplete.getPlace()
            // console.log("place =>"+ JSON.stringify(place , null , 2))
            let lat = place.geometry.location.lat()
            let lng = place.geometry.location.lng() 
            if (!place.geometry) {
                this.$toasted.show(this.$t("require.fillinMatchedChar"), {theme: 'bubble',   position: 'bottom-right',   type: 'error', duration: 15000});
            } else {
                showUserLocationOnTheMap(lat, lng , "mapReqr")           
                this.locReqr = {
                    lat : lat,
                    lng : lng
                }
                getAddressFrom(lat, lng, (res)=>{
                    if (res.resp == 'err') {
                        this.error = res.msg
                    } else {
                        this.contReqrAddress = res.msg
                        this.address = res.msg
                    }
                    this.spinner = false
                } )
            }
        })        
	},

	methods:{
        locatorButtonPressed(){
            this.spinner =true
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) =>{ 
                        let lat = position.coords.latitude
                        let lng = position.coords.longitude

                        showUserLocationOnTheMap(lat, lng, "mapReqr" )
                        this.locReqr = {
                            lat : lat,
                            lng : lng
                        }
                        getAddressFrom(lat, lng, (res)=>{
                            if (res.resp == 'err') {
                                this.error = res.msg
                            } else {
                                this.contReqrAddress = res.msg
                                this.address = res.msg
                            }
                            this.spinner = false
                        } )
                    },
                    error => {
                        this.error = "Locator is unable to find the address. Please type your address manually."
                        this.spinner =false
                    }
                );
            } else {
                this.error = error.message
                this.spinner =false
                // console.log(`Your browser does not support geolocation API. Please enter your address`);
            }
        },
        // showUserLocationOnTheMap(latitude , longitude){
        //     // Creat a map object
        //     let map = new google.maps.Map(document.getElementById("mapReqr"),{
        //         zoom:15,
        //         center: new google.maps.LatLng(latitude, longitude),
        //         mapTypeId: google.maps.MapTypeId.ROADMAP
        //     })
        //     // Add marker
        //     new google.maps.Marker({
        //         position: new google.maps.LatLng(latitude, longitude),
        //         map: map
        //     })
        //     // await new google.maps.marker.AdvanceedMarkerElement({
        //     //     position: await new google.maps.LatLng(latitude, longitude),
        //     //     map: map
        //     // })
        // },
        clearAddress(){
            this.address = ''
        },
        resetReceive(){
            if (this.jobType == 'Receive') {
                this.selectedTransCompId = ''
            }
        },
        showAC(){
            if (this.showAutoComplete == false) {
                this.showAutoComplete = true
            } else {
                this.showAutoComplete = false
            }
        },
        offAC(){
            if (this.showAutoComplete == true) {
                this.showAutoComplete = false
            } 
        },
        showMatchingTable( updatedRelsList){
            console.log (`updateRelsList.data (before nextTick) => ${JSON.stringify(updatedRelsList ,null, 2)}`)  
            this.items = updatedRelsList
            this.totalRows = updatedRelsList.length     
            this.isBusy = false
        },
        showModal() {
            this.$refs['reqr-modal'].show()
            this.isBusy = false            
        },
        async postItModal() {
            let totalReqrCost = reqrCost * parseInt(this.reqrQty)
            await getBalance(this.compId , async(res)=>{
                if (res < totalReqrCost) {
                    this.balanced = res 
                    this.showAlertWallet = true
                } else {
                    for (let i = 0; i < this.reqrQty; i++) {    
                        if (i==0) {
                            await saveWithId('Require', this.payload.reqrId, this.payload).then(()=>{
                            })   
                        } else {
                            this.payload.reqrId = `${this.payload.reqrId}-${i}`
                            await saveWithId('Require', this.payload.reqrId, this.payload).then(()=>{
                                this.payload.reqrId = this.payload.reqrId.split("-")[0]   // return to without '-'
                            })
                        }
                    } 
                    this.$toasted.show( `${this.reqrQty} ${this.$t("require.reqrWasPosted")}`, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});   
                    let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                    await uaTxWallet(totalReqrCost * -1, this.compId, slipId, "auto", "expense", "post require" , this.payload.reqrId)
                    this.refreshPostedRequire()
                    this.$refs['reqr-modal'].hide()                  
                    setTimeout(function () {
                        window.location.reload
                    },1000) 
                }
            })
        },
        doNotModal() {
            this.$refs['reqr-modal'].hide()
        },
        rowSelected(item) {
            this.selected = item
        },
        async selectBatchRow(){
            // console.log (`selectBatchRow, this.items => ${JSON.stringify(this.items ,null, 2)}`)  
            // console.log (`selectBatchRow, this.selected => ${JSON.stringify(this.selected ,null, 2)}`)  
            await this.makeMatchTx(this.selected, (res) => {
                if (res != "done") {
                    this.$toasted.show(this.$t("require.notMatched"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    this.items = []
                    this.totalRows = 0
                    this.selected =[]
                    this.minDetDate = ''
                    this.selectedBkgId = ''
                    this.contType = ''
                    this.contSize = ''
                    this.contGrade = ''
                    this.jobType = '' 
                }
            })
        },
        // Reason for not use select mode : "multi" , bcos it's hard to ensure that all selected items will be available for matching. We are in sharging resource.             
        // async makeMatchTx(selectedConts , cb){  // seleted release item.
        //     let selContQty = selectedConts.length
        //     let totalReqrCost = reqrCost * selContQty
        //     if (selContQty == 0) {
        //         this.$toasted.show(this.$t("require.noSelectedCont"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});   
        //     } else {
        //         await getBalance(this.compId, async(res)=>{
        //             if (res < totalReqrCost) {
        //                 this.balanced = res 
        //                 this.showAlertWallet = true
        //             } else {
        //                 for (let i = 0; i < selContQty; i++) {
        //                     await this.saveMatchTx(selectedConts[i]);
        //                 }
        //                 let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
        //                 await uaTxWallet(totalReqrCost * -1, this.compId, slipId, "auto", "expense", "match require" ,"Reqr cont(s): MatchTx")
        //                 this.$toasted.show(this.$t("require.makeMatchingTx"), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});                          
        //                 cb( "done")
        //             }
        //         })
        //     }
        // },
        async makeMatchTx(selectedCont , cb){  // seleted release item.
            let mTxId = `${this.$moment().format("YYMM")}`+'MT'+`${getRandomInt(10000 , 90000)}`
            // console.log(`selectedCont => ${JSON.stringify(selectedCont , null , 2)}`)
            if (selectedCont.length == 0) {
                this.$toasted.show(this.$t("require.noSelectedCont"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});   
            } else {
                await getBalance(this.compId, async(res)=>{
                    if (res < reqrCost) {
                        this.balanced = res 
                        this.showAlertWallet = true
                    } else {
                        await getStatusByDocId( "Release",selectedCont[0].relsId, async(res)=>{
                            if (res == "Matched") {
                                this.$toasted.show( this.$t("require.postedMatched"), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 10000}); 
                            } else {
                                await this.saveMatchTx(selectedCont[0] , mTxId);
                                let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                                await uaTxWallet(reqrCost * -1, this.compId, slipId, "auto", "expense", "match by require", mTxId,)
                                this.$toasted.show(this.$t("require.makeMatchingTx"), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});                          
                                cb( "done")
                            }
                        })
                    } 
                })
            }
        },
        async saveMatchTx( selCont , mTxId){
            let ts = Date.parse(new Date())
            const data = {
                mTxId : mTxId,
                bkgId: this.selectedBkgId,                
                contId : selCont.contId,
                contNo : selCont.contNo,
                agent: selCont.agent, 
                contType: selCont.contType,
                contSize: selCont.contSize,
                contGrade: selCont.contGrade,                               
                detDate : selCont.detDate,
                detTS : selCont.detTS,
                maxGross : selCont.maxGross,
                tare : selCont.tare,
                distance: selCont.distance,
                compNameLocalRels:selCont.compNameLocalRels,                
                contRelsAddress: selCont.contRelsAddress,
                locRels: selCont.locRels,  
                compNameLocalReqr :await compNameLocalByCompId(this.compId),                
                contReqrAddress: this.contReqrAddress, 
                locReqr: this.locReqr,  
                // jobTypeRels: selCont.jobType,
                // jobTypeReqr: this.jobType,
                // jobTypeRels : selCont.jobType != 'Either' ? selCont.jobType : this.jobType == 'Receive' ? 'Deliver' : this.jobType == 'Pick-up' ? 'NoDeliver' : 'NoDeliver',
                // jobTypeReqr : this.jobType != 'Either' ? this.jobType : selCont.jobType ==   'Deliver' ? 'Receive'  : selCont.jobType == 'NoDeliver' ? 'Pick-up' :'Pick-up',
                jobTypeRels : selCont.jobType != 'Either' ? selCont.jobType : this.jobType == 'Receive' ? 'Deliver' : 'NoDeliver',
                jobTypeReqr : this.jobType != 'Either' ? this.jobType : selCont.jobType ==   'Deliver' ? 'Receive'  : 'Pick-up',
                // transCompId : this.jobType == 'Receive' ? selBkgId.transCompId : this.jobType == 'Pick-up' ? this.selectedTransCompId :  this.selectedTransCompId,
                transCompId : this.jobType == 'Receive' ? selCont.transCompId :  this.selectedTransCompId,
                transStatus : 'waitAccept',
                sRelsTS :selCont.sRelsTS,
                sReqrTS :Date.parse(this.sReqrDate),
                msReqr: 'matched',
                jbReqr: 'waitAcceptReqr',
                actReqr:{
                    cancel:true, 
                    accept: false, 
                    reject:false, 
                    attachSeal:false
                },
                actRels:{
                    cancel:false,
                    accept: true,
                    reject:true,
                    // attachSeal:false
                },
                stepNo: 1,                                      
                msRels: 'matched',
                jbRels: 'offer',
                compIdRels:selCont.compId,
                compIdReqr : this.compId,
                userIdRels: selCont.userId,
                userIdReqr: this.userId,
                relsTS:selCont.timestamp,
                reqrTS: ts,
                // reqrId:this.reqrId,
                reqrId: "noPost",
                relsId:selCont.relsId,                
                txSearcher: "Require", 
                timestamp: ts,
                active: true,
                sealNo: "",
                shoreStatus:'waitRequest'                                        
            }
            await saveWithId('MatchTx', mTxId, data).then(async()=>{
                await updateStatus('Release', selCont.relsId, 'Matched')
                // await updateActive2False_Cont(selCont.contNo)  
                await saveWithId('jbStatusReqr' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbReqr : data.jbReqr,
                    timestamp : ts,
                })
                await saveWithId('jbStatusRels' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbRels : data.jbRels,
                    timestamp : ts,
                })
                await saveWithId('transStatus' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    transStatus : 'waitAccept',
                    timestamp : ts,
                })            
            })

        },
        handleSearching(){
            let msg = 'completed'
            if (this.selectedBkgId ==='') {
                msg = 'require.addSelectedBkgId'
            } else if (this.contReqrAddress ===''){
                msg = 'require.addContReqrAddress'
            } else if (this.locReqr== ''){
                msg = 'require.useGoogleMap'
            } else if (this.contType == ''){
                msg = 'require.selContType'
            } else if (this.contSize ===''){
                msg = 'require.selContSize'
            } else if (this.contGrade == ''){
                msg = 'require.selContGrade'
            } else if (this.minDetDate ===''){
                msg = 'require.selMinDetDate'
            } else if (this.distLim ===''){
                msg = 'require.addDistLim'
            } else if (this.sReqrDate ===''){
                msg = 'require.selStartReqrDate'
            } else if (Date.parse(this.sReqrDate) > Date.parse(this.minDetDate)){
                msg = 'require.sReqrDateMoreMinDetDate'
            } else if (isNaN(parseInt(this.distLim))){
                msg = 'require.distLimNumber'
            } else if (this.jobType ===''){
                msg = 'release.selJobType'
            } else if (this.jobType !=='Receive'){
                if (this.selectedTransCompId == '') {
                   msg = 'release.selTruckComp' 
                } 
            }  
            if (msg === 'completed'){
                this.items = []   // clear data in the matching table
                agentAtBkgId(this.selectedBkgId , this.compId, async(ag)=>{
                    this.isBusy = true  // turn om spiner
                    this.agent = ag
                    let YYMM = this.$moment().format("YYMM")
                    this.reqrId = YYMM+'RQ'+`${Math.floor(Math.random() * (90000 - 10000 + 1) + 10000)}`
                    let mDetDate = this.$moment(this.minDetDate).format("YYYY-MM-DD")
                    let mDetTS = Date.parse(mDetDate + ' ' + '23:59:59')
                    const payload = {
                        reqrId : this.reqrId,
                        bkgId : this.selectedBkgId,
                        distLim : parseInt(this.distLim),
                        contReqrAddress: this.contReqrAddress,
                        locReqr: this.locReqr,            
                        minDetDate : mDetDate,
                        minDetTS: mDetTS,
                        contType : this.contType,
                        contSize : this.contSize,
                        contGrade : this.contGrade,
                        agent : ag,
                        jobType : this.jobType,
                        transCompId :this.selectedTransCompId,
                        sReqrTS :Date.parse(this.sReqrDate),
                        compId : this.compId,
                        compNameLocalReqr : await compNameLocalByCompId(this.compId),
                        userId : this.userId,
                        status: "Require",
                        timestamp: Date.parse(new Date())
                    }
                        // testIndexRelease( payload , (res)=>{
                        //     console.log(`testIndexRelesse => ${JSON.stringify(res , null ,2)}`)
                        // })                    
                    // console.log ('payload=>'+JSON.stringify(payload , null, 2))  

                    const functionsURL ='https://matchedreqr-7gonzgqu6a-as.a.run.app'       
                    axiosPost(functionsURL, payload, (res)=>{
                        if (res.resp == 'err') {
                            this.$toasted.show( `Network Error : ${res.data}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});       
                        } else {
                            if (res.data.length == 0) {
                                this.payload = payload
                                this.showModal()                              
                            } else {
                                this.showMatchingTable(res.data)
                            }
                        }
                    })
                })                                              
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        // PostedReqr
        async refreshPostedRequire() {
            await getData( "Require", "compId",this.compId , (res)=>{
                this.itemsPostedReqr = res
                this.totalRowsPostedReqr = res.length
            })
            this.selectedTransCompId = ''
            this.sReqrDate = ''
            this.jobType = ''
            this.reqrQty = 1
            this.reqrQtyList = []
        },
        actPostedReqrCancel(item) {
            this.$bvModal.msgBoxConfirm(this.$t('require.confirmCancelMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                if (value) {
                    getStatusByDocId( "Require", item.reqrId, async(res)=>{
                        if (res == "Matched") {
                            this.$toasted.show( this.$t("require.postedMatched"), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 10000});  
                        } else {
                            updateStatus('Require', item.reqrId, 'Cancel')
                            this.refreshPostedRequire()
                            let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                            await uaTxWallet(reqrCost, this.compId, slipId, "auto", "refund", "cancel posted require",item.reqrId)
                            this.$toasted.show( this.$t("require.postedCancelled"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});                              
                            setTimeout(function () {
                                window.location.reload
                            },1000) 
                        }
                    })
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Cancel: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
            })
        }, 
        async openModalImage(item, index, button) {
            await getData('Container' , 'contId' , item.contId , (res)=>{
            this.imageUriModal = res[0].url6  
            this.modalTitle = res[0].contNo   
            this.$root.$emit('bv::show::modal', "contModal" , button)                                  
            })
        },
        resetInfoModal() {
            this.modalTitle = ''
            this.imageUriModal = []
        },
        scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
.ui.button,
.dot.circle.icon{
    background-color: #138fc0;
    color : white
}
#mapReqr {
    position:absolute;
    top:0;
    right:0;
    bottom: 0;
    left: 0;
    background: blue;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  /* text-transform: lowercase;
  font-variant: small-caps; */
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.divider {
        height: 1px;
        background-color: #0f0f0f;
        margin:5px
    }
    .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}
.display-image {
width: 100%;
  height: 400px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
  }
  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>
